var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAccessKeyMetrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C7CFE2"
    },
    points: "239.484,363.355 156.903,363.355 148.645,421.161 247.742,421.161 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFB9D2"
    },
    points: "243.023,388.129 239.484,363.355 156.903,363.355 153.364,388.129 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M379.871,371.613H16.516C7.395,371.613,0,364.217,0,355.096v-256c0-9.122,7.395-16.516,16.516-16.516 h363.355c9.122,0,16.516,7.395,16.516,16.516v256C396.387,364.217,388.993,371.613,379.871,371.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M16.516,82.581C7.395,82.581,0,89.975,0,99.097v256c0,9.121,7.395,16.516,16.516,16.516h272.516 L107.355,82.581H16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M379.871,82.581H16.516C7.395,82.581,0,89.975,0,99.097v231.226h396.387V99.097 C396.387,89.975,388.992,82.581,379.871,82.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M0,99.097v231.226h263.078L107.355,82.581H16.516C7.395,82.581,0,89.975,0,99.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M363.355,305.548H33.032c-4.561,0-8.258-3.697-8.258-8.258V115.613c0-4.561,3.697-8.258,8.258-8.258 h330.323c4.561,0,8.258,3.697,8.258,8.258V297.29C371.613,301.851,367.916,305.548,363.355,305.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M429.423,222.968H313.806c-9.122,0-16.516,7.395-16.516,16.516v173.419 c0,9.122,7.395,16.516,16.516,16.516H429.42c9.121,0,16.516-7.394,16.516-16.516l0.003-173.42 C445.939,230.362,438.544,222.968,429.423,222.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M297.29,239.484v173.419c0,9.121,7.395,16.516,16.516,16.516h115.613L313.806,222.968 C304.685,222.968,297.29,230.362,297.29,239.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M433.548,404.645H309.677c-2.28,0-4.129-1.849-4.129-4.129V251.871c0-2.28,1.849-4.129,4.129-4.129 h123.871c2.28,0,4.129,1.849,4.129,4.129v148.645C437.677,402.797,435.829,404.645,433.548,404.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M355.097,338.581h148.645c4.561,0,8.258,3.697,8.258,8.258v74.323c0,4.561-3.697,8.258-8.258,8.258 H355.097c-4.561,0-8.258-3.697-8.258-8.258v-74.323C346.839,342.278,350.536,338.581,355.097,338.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M355.097,338.581c-4.561,0-8.258,3.697-8.258,8.258v74.323c0,4.56,3.697,8.258,8.258,8.258h99.097 l-49.548-90.839H355.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M264.258,429.419H132.129c-4.565,0-8.258-3.698-8.258-8.258s3.694-8.258,8.258-8.258h132.129 c4.565,0,8.258,3.698,8.258,8.258S268.823,429.419,264.258,429.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M206.452,359.226h-16.516c-4.561,0-8.258-3.697-8.258-8.258l0,0c0-4.561,3.697-8.258,8.258-8.258 h16.516c4.561,0,8.258,3.697,8.258,8.258l0,0C214.71,355.529,211.012,359.226,206.452,359.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00D2FF"
    },
    d: "M483.097,421.161H375.742c-2.28,0-4.129-1.849-4.129-4.129v-66.065c0-2.28,1.849-4.129,4.129-4.129 h107.355c2.28,0,4.129,1.849,4.129,4.129v66.065C487.226,419.313,485.377,421.161,483.097,421.161z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAccessKeyMetrics);
export default __webpack_public_path__ + "static/media/mobile-access-key-metrics.6a14fe994a7b4a49f61ac2d4cde8f1f0.svg";
export { ForwardRef as ReactComponent };